import { render, staticRenderFns } from "./vehicleRepairBreakdown.vue?vue&type=template&id=66ef74d0"
import script from "./vehicleRepairBreakdown.vue?vue&type=script&lang=js"
export * from "./vehicleRepairBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports